import {Component, Input, OnInit} from '@angular/core';
import {OfferService} from '../../../../../core/services/impl/offer.service';
import {MissingCalculationParam} from '../../../../../core/consts/missing-calculation-param.enum';
import {TranslateService} from '@ngx-translate/core';
import {StepKey} from '../../../../../core/enums/step-key.enum';
import {NavigateManagerService} from '../../../../../core/services/navigate-manager.service';
import {OfferSectionStateService} from '../../../../../core/services/impl/section-services/offers/offer-section-state.service';
import {orderCall} from '../../../../../core/utils/utils';

@Component({
  selector: 'app-missing-data-offer',
  templateUrl: './missing-data-offer.component.html',
  styleUrls: ['./missing-data-offer.component.scss']
})
export class MissingDataOfferComponent implements OnInit {

  @Input() type: MissingDataOfferComponentType;
  @Input() logos: string[];
  @Input() faded: boolean;

  private translationContainer = 'MISSING_DATA_OFFER_COMPONENT';

  get displayedBetweenOffers(): boolean {
    return this.offerSectionStateService.offers.length >= this.offerService.minOffersAmountForMixedInReadonlyBoxes;
  }

  get topInfo(): string {
    const topInfo = `${this.translationContainer}.TOP_INFO`;
    return this.type === MissingDataOfferComponentType.PERSONAL_DATA ? `${topInfo}.personalData` : `${topInfo}.registrationNumber`;
  }

  get missingParamsInfo(): string {
    if (this.type === MissingDataOfferComponentType.REGISTRATION_NUMBER) {
      return `${this.translationContainer}.MISSING_PARAMS_INFO.registrationNumber`;
    } else {
      return this.createMissingPersonalDataInfo();
    }
  }

  constructor(private offerService: OfferService,
              private offerSectionStateService: OfferSectionStateService,
              private navigateManagerService: NavigateManagerService,
              private ts: TranslateService) { }

  ngOnInit() {
  }

  backToData(): void {
    if (this.type === MissingDataOfferComponentType.REGISTRATION_NUMBER) {
      this.navigateManagerService.moveToFirstStep();
    } else {
      this.navigateManagerService.moveToPersonalDataStep();
    }
  }

  orderCall(): void {
    orderCall();
  }

  private createMissingPersonalDataInfo(): string {
    let missingParamsString;
    const missingParamsTranslations = this.offerService.missingPersonalDataParams.map(param => {
      switch (param) {
        case MissingCalculationParam.FIRST_NAME:
          return this.ts.instant('MISSING_PERSONAL_DATA_DIALOG_COMPONENT.firstName');
        case MissingCalculationParam.LAST_NAME:
          return this.ts.instant('MISSING_PERSONAL_DATA_DIALOG_COMPONENT.lastName');
        case MissingCalculationParam.PESEL:
          return this.ts.instant('MISSING_PERSONAL_DATA_DIALOG_COMPONENT.pesel');
      }
    });
    if (missingParamsTranslations.length === 1) {
      missingParamsString = missingParamsTranslations[0];
    } else {
      const firstParamsString = missingParamsTranslations.slice(0, missingParamsTranslations.length - 1).join(', ');
      const and = this.ts.instant(`${this.translationContainer}.MISSING_PARAMS_INFO.and`);
      missingParamsString = `${firstParamsString} ${and} ${missingParamsTranslations[missingParamsTranslations.length - 1]}`;
    }

    return this.ts.instant(`${this.translationContainer}.MISSING_PARAMS_INFO.personalData`, { missingPersonalParams: missingParamsString });
  }

}

export enum MissingDataOfferComponentType {
  PERSONAL_DATA = 'PERSONAL_DATA',
  REGISTRATION_NUMBER = 'REGISTRATION_NUMBER',
}
